import { render } from "./login.vue?vue&type=template&id=a0083200&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=a0083200&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a0083200"

export default script